import React from 'react'
import { Container, Row } from "react-bootstrap";
import { useLocation } from 'react-router-dom';
import { useGetGoogleAnalyticsRealTimeReport } from '../../hooks/google-analytics/google-analytics.hook';
import { WorldMap } from '../../maps/world-map';
import { t } from '../../localization/localization';
import { useState } from 'react';


const ReportsWorldChart = () => {
  const search = useLocation().search;
  const urlSearchParam = new URLSearchParams(search);
  const locale = urlSearchParam.get("locale");
  const { data, isLoading } = useGetGoogleAnalyticsRealTimeReport();


  const [currentDate, setCurrentDate] = useState("")

  function updateDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = ("0" + (now.getMonth() + 1)).slice(-2);
    const day = ("0" + now.getDate()).slice(-2);
    const hour = ("0" + now.getHours()).slice(-2);
    const minutes = ("0" + now.getMinutes()).slice(-2);
    const seconds = ('0' + now.getSeconds()).slice(-2);
    setCurrentDate(`${year}-${month}-${day} ${hour}:${minutes}:${seconds}`)
  }
  setInterval(updateDate, 1000);
  return (
    <Container>
      <Row>
        <h3>{t(locale, "/reports/reportsCount")}</h3>
      </Row>
      <Row>
        {!isLoading && (
          <WorldMap
            startDate={t(locale,"/charts/handle/world-map-current")}
            endDate={currentDate}
            mapData={data.rows.map((element) => {
              return { name: element[0], value: element[1] };
            })}
          />
        )}
      </Row>
    </Container>
  );
}

export default ReportsWorldChart